import React, { useState, useEffect } from "react";
import { Container, Col, Image, Row, OverlayTrigger, Popover } from "react-bootstrap";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Avatar } from "antd";
// import logoImage from "../assets/img/logoShirood.png"
// import logoImage from "../assets/img/logoAmol.png"
import logoImage from "../assets/img/logoSalmanShahr.png"
import Sidebar from "./Sidebar";
import routes from "../routes";
import { useUserSession } from "./user-context";
import { apiUrl } from "../commons/inFormTypes";
import "react-toastify/dist/ReactToastify.css";


function Header() {
  const [isToggle, setIsToggle] = useState(false);
  const [user1, setUser1] = useState(localStorage.getItem("user_namefamily"))
  const [image, setImage] = useState(localStorage.getItem("user_profile"));
  const { user, logOut } = useUserSession();
  const [seenFile, setSeenFile] = useState({});
  const navigate = useNavigate();
  const { pathname } = useLocation()

  useEffect(() => {
    setUser1(localStorage.getItem("user_namefamily"));
    const axios = require("axios");
    axios({
      method: "get",
      url: apiUrl + "settings",
      headers: {},
    }).then((res) => {
      setSeenFile(res.data.data)
    });
  }, [])




  const toggleHandler = () => {
    if (isToggle) setIsToggle(false);
    else setIsToggle(true);
  };

  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3"> <i class="far fa-question-circle p-1"></i> راهنما</Popover.Header>
      <Popover.Body>
        در این قسمت شما می توانید با انتخاب واحد مرتبط با درخواست مورد نظر خود، به فرم مورد نظر دسترسی
        پیدا کرده و بعد از تکمیل فرم و ثبت درخواست با دریافت یک کد رهگیری از قسمت لیست درخواست ها و یا پیگیری درخواست ها،
        نسبت به پیگیری درخواست یا مشکل مطرح شده خود اقدام نمایید.
        <br />
        همچنین در صورت عدم آگاهی نسبت به واحد مرتبط، می توانید از قسمت جستجو، عنوان یا کلمه مورد نظر را
        تایپ و نوع موضوع خود را انتخاب نمایید و به فرم مربوطه هدایت شوید.
        {/* And here's some <strong>amazing</strong> content. It's very engaging.
        right? */}
      </Popover.Body>
    </Popover>
  );


  return (
    <div>
      <header>
        <Container fluid className="rgc-header pt-2">
          {pathname === "/admin/dashboard" ?
            <Row className="justify-content-center align-items-center">

              <Col xs={2} className="d-block d-lg-none">
                <div className="header_toggle">
                  <i
                    onClick={toggleHandler}
                    className="fa fa-bars"
                    aria-hidden="true"
                    id="header-toggle1"
                  ></i>
                </div>
              </Col>

              <Col lg={4} className="d-none d-lg-block text-end">
                <div className="d-flex align-items-center justify-content-start">
                  <div>
                    <NavLink to="profile" aria-current="page">
                      <Avatar
                        className="fa fa-user-circle rgc-avatar"
                        size="large"
                        src={image}
                      />
                    </NavLink>
                  </div>

                  <div>
                    {!user.Islogin ? (
                      <NavLink to="/" className="style-nav m-3">
                        {user1}
                      </NavLink>
                    ) : (
                      <NavLink to="profile" className="style-nav m-3">
                        {user1}
                      </NavLink>
                    )}

                  </div>

                </div>
              </Col>

              <Col xs={8} lg={4} className="text-center">
                <div className="rgc-logo-part">
                  <Image src={seenFile.logo} />
                  <div className="rgc-logo-par-txt">
                    <span>{seenFile.title}</span>
                  </div>
                </div>
              </Col>

              <Col xs={2} lg={4} className="text-start">
                <OverlayTrigger trigger="click" placement="right" overlay={popover}>
                  <div className='rgc-icon-style me-auto'>
                    <i className="fa fa-question"></i>
                  </div>
                </OverlayTrigger>
              </Col>

            </Row>
            :
            <Row className='justify-content-center justify-content-md-around' >
              <Col xs={2} className="text-end text-md-center">
                <div className='rgc-icon-style' onClick={() => navigate(-1)}>
                  <i className="fa fa-arrow-right"></i>
                </div>
              </Col>

              <Col xs={8} className="text-center rgc-header-title">
               <div className="rgc-logo-part">
                  <Image src={seenFile.logo} />
                  <div className="rgc-logo-par-txt">
                    <span>{seenFile.title}</span>
                  </div>
                </div>
              </Col>

              <Col xs={2} className="text-start text-md-center">
                <NavLink to='dashboard' aria-current="page" className='rgc-icon-style me-auto'>
                  <i className="fas fa-home"></i>
                </NavLink>
              </Col>
            </Row>
          }
        </Container>
      </header>
      {pathname === "/admin/dashboard" &&
        <Sidebar routes={routes} toggle={isToggle} toggleHandler1={toggleHandler} />
      }

    </div>
  );
}

export default Header;
